import { Component, computed, Inject, Signal } from '@angular/core'
import { AppMode } from '@ftr/contracts/api/user'
import { BadgeColors, BadgeComponent, Icon } from '@ftr/foundation'
import { APP_MODE } from '@ftr/routing-paths'

interface PortalBadgeConfig {
  icon: Icon
  badgeColor: BadgeColors
}

@Component({
  selector: 'ftr-portal-badge',
  templateUrl: './portal-badge.component.html',
  imports: [BadgeComponent],
})
export class PortalBadgeComponent {
  readonly portalBadgeConfig = computed(() => getPortalBadgeConfig(this.appMode()))

  constructor(@Inject(APP_MODE) private readonly appMode: Signal<AppMode>) {}
}

function getPortalBadgeConfig(appMode: AppMode): PortalBadgeConfig | undefined {
  if (appMode === 'public') {
    return {
      icon: 'PeopleLine',
      badgeColor: BadgeColors.Blueberry,
    }
  }
  if (appMode === 'courts') {
    return {
      icon: 'Courthouse',
      badgeColor: BadgeColors.Mint,
    }
  }
  return undefined
}
